import edap from '../collaborate/edap';
import gql from 'graphql-tag';

export const Voter = {
    firstName: null,
    lastName: null,
    publicImageUrl: null
};

export const Vote = {
    isMine: false,
    uuid: null,
    voter: {...Voter}
};

export const GET_VOTES = gql`
    query unitVotes($hav: String!, $tripBoardUuid: String!, $unitTriad: String!) {
        unitVotes(hav: $hav, tripBoardUuid: $tripBoardUuid, unitTriad: $unitTriad) {
            myVote {
                isMine
                uuid
                voter {
                    firstName
                    lastName
                    publicImageUrl
                }
            }
            totalVotes
            votes {
                isMine
                uuid
                voter {
                    firstName
                    lastName
                    publicImageUrl
                }
            }
        }
    }
`;

export const ADD_VOTE = gql`
    mutation addOrGetVote($hav: String!, $tripBoardUuid: String!, $unitTriad: String!) {
        addOrGetVote(hav: $hav, tripBoardUuid: $tripBoardUuid, unitTriad: $unitTriad) {
            uuid
            isMine
            voter {
                firstName
                lastName
                publicImageUrl
            }
        }
    }
`;

export const REMOVE_VOTE = gql`
    mutation removeVoteFromTripBoardUnit($hav: String!, $voteUuid: String!) {
        removeVoteFromTripBoardUnit(hav: $hav, voteUuid: $voteUuid)
    }
`;

export const getCache = (proxy, variables) => {
    return proxy.readQuery({query: GET_VOTES, variables}) || {};
};

export const queryOptions = ({hav, listingId, tripBoardUuid}) => {
    // eslint-disable-line
    return {
        variables: {
            hav,
            tripBoardUuid,
            unitTriad: listingId
        },
        notifyOnNetworkStatusChange: false,
        errorPolicy: 'all',
        skip: !hav || !listingId || !tripBoardUuid
    };
};

export const updateAdd = (proxy, data, variables) => {
    const vote = data && data.addOrGetVote;
    const cache = getCache(proxy, variables);
    // were we successful?
    if (vote && cache.unitVotes) {
        cache.unitVotes.myVote = vote;
        cache.unitVotes.totalVotes++;
        cache.unitVotes.votes = cache.unitVotes.votes || [];
        cache.unitVotes.votes.push(vote);
        proxy.writeQuery({query: GET_VOTES, variables, data: cache});
    }
};

export const updateRemove = (proxy, uuid, variables) => {
    const cache = getCache(proxy, variables);

    // were we successful?
    if (uuid && cache.unitVotes) {
        cache.unitVotes.myVote = null;
        cache.unitVotes.totalVotes--;
        cache.unitVotes.votes = cache.unitVotes.votes || [];
        cache.unitVotes.votes = cache.unitVotes.votes.filter((vote) => vote.uuid !== uuid);
        proxy.writeQuery({query: GET_VOTES, variables, data: cache});
    }
};

export const voteUp = ({hav, listingId: unitTriad, mutate, tripBoardUuid, endDate, startDate, role, voter = {}}) => {
    const variables = {
        hav,
        tripBoardUuid,
        unitTriad
    };
    edap.votedUp(tripBoardUuid, endDate, unitTriad, startDate, role);
    /* istanbul ignore next */
    mutate({
        variables,
        optimisticResponse: {
            addOrGetVote: {
                uuid: '-1',
                isMine: true,
                voter: {
                    ...voter,
                    __typename: 'TripBoardUserProfile'
                },
                __typename: 'Vote'
            }
        },
        /* istanbul ignore next */
        update: (proxy, {data}) => {
            /* istanbul ignore next */
            updateAdd(proxy, data, variables);
        }
    });
};

export const voteDown = ({endDate, hav, listingId: unitTriad, mutate, startDate, tripBoardUuid, uuid, role}) => {
    const variables = {
        hav,
        tripBoardUuid,
        unitTriad
    };

    edap.votedDown(tripBoardUuid, endDate, unitTriad, startDate, role);

    /* istanbul ignore next */
    mutate({
        variables: {
            hav,
            voteUuid: uuid
        },
        optimisticResponse: {removeVoteFromTripBoardUnit: true},
        /* istanbul ignore next */
        update: (proxy) => {
            /* istanbul ignore next */
            updateRemove(proxy, uuid, variables);
        }
    });
};



// WEBPACK FOOTER //
// ./src/universal/tripboard/votes/votes-graphql.js